import React from "react";
import ReactDOM from "react-dom";
// import "./index.css";
import '../src/utils/prefixUtility';
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("app-container")
);
